import Link_Arrow_Btn from "@/components/ui/link_arrow_btn";
import SectionTitle from "@/components/ui/section-title";
import Link from "next/link";
import { MEDIA_BASE_URL } from "@/utils/api";
const Link_Button_Sec = ({ productDetails }) => {
  // Extract pdf links
  const mediaBaseUrl = MEDIA_BASE_URL;
  const linkBtnData = {
    "technical guide": productDetails?.technical_guide,
    "selection guide": productDetails?.selection_guide,
    "installation guide": productDetails?.installation_guide,
  };

  // Check if there is at least one non-null link
  const hasLinks = Object.values(linkBtnData).some(value => value);
  // If no links, return null to hide the section
  if (!hasLinks) return null;

  return (
    <section className="bg-[#F6F6F6] py-5 lg:py-[2.5vw]">
      <div className="container md:flex md:flex-wrap justify-between items-end">
        <div className="md:flex-[0_0_auto] lg:w-[15vw] mb-4 lg:mb-0">
          <SectionTitle
            title={"Simpolo Ultimate Guide"}
            customClass={`!mb-0`}
          />
        </div>
        {
          <div className="md:flex-[0_0_auto] flex flex-wrap gap-5 lg:gap-[2vw]">
            {Object.entries(linkBtnData)
              .filter(([key, value]) => value) // Filter out undefined values
              .map(([key, value], i) => (
                <Link_Arrow_Btn
                  link={`${mediaBaseUrl}${value}` ?? ''}
                  text={key}
                  key={i}
                  customClass={`border-black border-[1px] block p-4 leading-[1] uppercase tracking-wide text-black font-secondary`}
                />
              ))}
          </div>
        }

      </div>
    </section>
  );
};

export default Link_Button_Sec;
